import * as React from 'react';
import bind from '../bind';

interface Props {
  verticalOffset: number;
  onlyScrollUp?: boolean;
}

class ScrollTarget extends React.Component<Props, null> {
  scrollTarget = null;

  static defaultProps = {
    verticalOffset: 0,
  };

  constructor(props) {
    super(props);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  @bind
  createRef(element) {
    this.scrollTarget = element;
  }

  scrollToTop() {
    if (this.shouldScroll()) {
      window.scrollTo(0, this.clientTop + window.scrollY);
    }
  }

  shouldScroll() {
    if (this.props.onlyScrollUp) {
      return this.clientTop < 0;
    }
    return true;
  }

  get clientTop() {
    const _scrollTarget = this.scrollTarget as any;
    return _scrollTarget.getBoundingClientRect().top + this.props.verticalOffset;
  }

  render() {
    return (
      <div className="offset-anchor-wrapper">
        <div className="offset-anchor scrollTarget" ref={this.createRef}></div>
      </div>
    );
  }
}

export default ScrollTarget;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/scroll_target.tsx